// https://vuex.vuejs.org/en/getters.html
import axios from "../axios-auth";
import axiosApi from "../axios-api";
import axiosOld from "../axios-old";
import router from "../router";

export default {
  // userMail (state) {
  //   return state.mail
  // }
  project(state) {
    return state.project;
  },
  subProject(state) {
    return state.subProject;
  },
  CEReports(state) {
    return state.CEReports;
  },
  Data2(state) {
    return state.Data2;
  },
  proDevices(state) {
    let proDevices = state.agroBot.concat(state.agroBotComp);
    proDevices = proDevices.concat(state.agroBotBasic);

    function parseHumidity(raw) {
      let vwc =
        (6.77 * Math.pow(10, -10) * Math.pow(raw, 3) -
          5.105 * Math.pow(10, -6) * Math.pow(raw, 2) +
          1.302 * Math.pow(10, -2) * raw -
          10.848) *
        100;
      return vwc;
    }

    function ecParser(rawHumidity, rawEC, vwc, Tsoil) {
      //Parsed Volumetric Water Content
      let Om = vwc / 100;

      //ELECTRICAL CONDUCTIVITY DESTILLED WATER
      let Od = 0;

      //USING EXAMPLE 1.5Mg/m3 REAL 1.48
      let Pb = 1.5;

      //USING EXAMPLE 2.65Mg/m3
      let Ps = 2.65;

      //Dielectric permittivity
      let Ep = 80.3 - 0.37 * Tsoil - 20;

      //Segun HILHOST 2000!?
      let Eab = 4.1;

      //Real portion of the dielectric permittivity of the bulk soil
      let Eb = Math.pow(
        2.887 * Math.pow(10, -9) * Math.pow(rawHumidity, 3) -
        2.08 * Math.pow(10, -5) * Math.pow(rawHumidity, 2) +
        5.276 * Math.pow(10, -2) * rawHumidity -
        43.39,
        2
      );

      //Pore water conductivity
      let Op = (Ep * rawEC) / (Eb - Eab);

      let Porosity = 1 - Pb / Ps;

      //Saturation extract EC
      let solutionEC = (Op * Om + Od) / Porosity;

      return solutionEC;
    }

    proDevices.forEach(async (Device) => {
      // let Tsoil = Device.specificTypeParameters.soilTemperature;
      // let vwc = parseHumidity(
      //   Device.specificTypeParameters.volumetricWaterContent
      // );
      // let rawHumidity = Device.specificTypeParameters.volumetricWaterContent;
      // let rawEC = Device.specificTypeParameters.electricConductivity;
      // Device.specificTypeParameters.volumetricWaterContent = Math.round(vwc);
      // Device.specificTypeParameters.electricConductivityParsed = (
      //   ecParser(rawHumidity, rawEC, vwc, Tsoil) * 1.637 +
      //   0.556
      // ).toFixed(2);

      // let date = new Date().toISOString().substr(0, 10);
      // let yesterday = new Date(new Date(date).setHours(0));
      // let today = new Date(new Date(date).setHours(24));
      // yesterday.setDate(yesterday.getDate() - 1);
      // today.setDate(today.getDate());

      // let params = {
      //   sigfoxDeviceId: Device.sigfoxId,
      //   startDate: yesterday,
      //   endDate: today,
      // };

      // await axiosApi
      //   .get(`https://listener.rabiahostal.com.mx/api/message/get-by-device`, {
      //     params,
      //   })
      //   .then((response) => {
      //     // console.log("Message", response.data);
      //     // console.log("Message", response.data);
      //     let payload =
      //       ((response.data[response.data.length - 25].pulseCounter -
      //         response.data[response.data.length - 25].pulseCut) *
      //         10) /
      //       2;

      //     console.log("payload", payload);

      //     Device.specificTypeParameters.yesterdayTotalPulses = payload;
      //   });

      // // for (const Comp of newDevices) {
      // for (const Comp of state.devices) {
      //   // newDevices.forEach(async (Comp) => {
      //   let name = Device.name.split("-");
      //   let name2 = Comp.name.split("-");

      //   console.log("Name", name[0]);
      //   console.log("Name2", name2[0], Comp);
      //   if (name[0] == name2[0]) {
      //     console.log("chy", name[0]);
      //     let date = new Date().toISOString().substr(0, 10);
      //     let yesterday = new Date(new Date(date).setHours(0));
      //     let today = new Date(new Date(date).setHours(24));
      //     yesterday.setDate(yesterday.getDate() - 1);
      //     today.setDate(today.getDate());

      //     let params = {
      //       sigfoxDeviceId: Comp.sigfoxId,
      //       startDate: yesterday,
      //       endDate: today,
      //     };

      //     Device.specificTypeParameters.pH =
      //       Comp.specificTypeParameters.humidity / 1000;
      //     Device.specificTypeParameters.pH = (
      //       -7.2 * Device.specificTypeParameters.pH +
      //       15.509
      //     ).toFixed(2);

      //     await axiosApi
      //       .get(`https://listener.rabiahostal.com.mx/api/message/get-by-device`, {
      //         params,
      //       })
      //       .then((response) => {
      //         console.log("Message", response.data);
      //         let payload =
      //           (response.data[response.data.length - 25].pulse -
      //             response.data[response.data.length - 25].pulseCut) *
      //           10;
      //         console.log("payload", payload);

      //         Device.specificTypeParameters.yesterdayTotalPulsesComp = payload;
      //       });
      //   } else {
      //     console.log("chompiras");
      //   }
      //   // });
      // }
    });
    console.log("proDevices", proDevices);
    // commit("proDevices", this.proDevices);

    return proDevices;
  },
};
